// ============================================
// NOTFOUND.JS - Página 404
// Ruta: cualquier ruta no encontrada /*
// ============================================

import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../components/SEO";
import "./NotFound.css";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-root">
      <SEO
        title="Página no encontrada"
        description="La página que buscas no existe o fue movida."
        noindex
      />
      <div className="notfound-container">

        {/* Número grande decorativo */}
        <div className="notfound-bg-number">404</div>

        {/* Contenido central */}
        <div className="notfound-content">
          <p className="notfound-label">Página no encontrada</p>
          <h1 className="notfound-title">
            Parece que esta página<br />se perdió en el ritual.
          </h1>
          <p className="notfound-desc">
            La dirección que buscas no existe o fue movida.<br />
            Vuelve al inicio o explora el catálogo.
          </p>

          <div className="notfound-actions">
            <button
              className="notfound-btn-primary"
              onClick={() => navigate("/")}
            >
              Ir al inicio
            </button>
            <button
              className="notfound-btn-secondary"
              onClick={() => navigate("/shop")}
            >
              Ver catálogo
            </button>
          </div>
        </div>

        {/* Línea decorativa */}
        <div className="notfound-line" />

        {/* Links útiles */}
        <div className="notfound-links">
          <span className="notfound-links-label">¿Buscabas algo específico?</span>
          <button className="notfound-link" onClick={() => navigate("/shop")}>Tienda</button>
          <span className="notfound-dot">·</span>
          <button className="notfound-link" onClick={() => navigate("/account")}>Mi cuenta</button>
          <span className="notfound-dot">·</span>
          <button className="notfound-link" onClick={() => navigate("/")}>Inicio</button>
        </div>

      </div>
    </div>
  );
}
